import {axiosGetHandler, axiosPostHandler} from './config'
import {extractAPIValues} from '_lib/utils/utils'
const {BASE_API, BASE_XHH} = extractAPIValues()

// 获取组队游戏信息
export function getTeamGames (args) {
  let url = BASE_API + '/chatroom/v2/room/team_games'
  return axiosGetHandler(url, args)
}

// 房间频道绑定组队游戏
export function bindTeamGame (args, formdata) {
  let url = BASE_API + '/chatroom/v2/room/bind_team'
  return axiosPostHandler(url, args, formdata)
}

// 获取匹配配置
export function getMatchConfig (args) {
  let url = BASE_API + '/chatroom/v2/team/matching/config'
  return axiosGetHandler(url, args)
}

// 开始匹配
export function startMatch (args, formdata) {
  let url = BASE_API + '/chatroom/v2/team/matching/start'
  return axiosPostHandler(url, args, formdata)
}

// 准备
export function matchReady (args, formdata) {
  let url = BASE_API + '/chatroom/v2/team/matching/ready'
  return axiosPostHandler(url, args, formdata)
}